import { createTimeline, stagger, splitText } from '../../vendor/anime.esm.js';
import { DURATION, EASE, SPRING_PRESETS, resolveDuration, BLUR } from '../motion-tokens.js';

export const ctaBar = (el) => {
    // PRIMARIO: botón CTA spring bounce desde abajo. SECUNDARIO: título fade-up lento.
    const title   = el.querySelector('h2, h3, .cta-title, .banner-text');
    const btn     = el.querySelector('.btn, .cta-btn, button, a[href].btn');
    const section = el.querySelector('section');

    // Estado inicial forzado (antes de anime-init)
    if (section) { section.style.opacity = '0'; section.style.transform = 'scaleX(0.96)'; }
    if (title)   { title.style.opacity = '0'; title.style.transform = 'translateY(25px)'; title.style.filter = 'blur(4px)'; }
    if (btn)     { btn.style.opacity = '0'; btn.style.transform = 'translateY(25px)'; }

    const tl = createTimeline({ defaults: { ease: EASE.refined }, });

    // Estiramiento elástico en el contenedor de fondo para acoplamiento físico
    if (section) {
        tl.add(section, {
            scaleX: [0.96, 1],
            opacity: [0, 1],
            duration: resolveDuration(DURATION.slow),
            ease: SPRING_PRESETS.cinematic,
        }, 0);
    }

    // Secundario: título entra con peso
    if (title) tl.add(title, {
        opacity:    [0, 1],
        translateY: [25, 0],
        filter:     ['blur(4px)', 'blur(0px)'],
        duration:   resolveDuration(DURATION.dramatic),
    }, section ? '-=600' : 0);

    // Primario: botón CTA con spring físico deluxe
    if (btn) {
        tl.add(btn, {
            opacity:    [0, 1],
            translateY: [25, 0],
            duration:   resolveDuration(DURATION.normal),
            ease:       SPRING_PRESETS.magnetic,
        }, '-=800');
    }

    return tl;
};

export const bannerAnim = (el) => {
    // TÍTULO (palabras), SUBTEXTO (fade-up), BOTÓN (spring bounce al final)
    const textEl  = el.querySelector('.banner-text, h2, h3, [class*="banner-title"]');
    const badge   = el.querySelector('.badge, .banner-badge, .banner-icon, [class*="badge"]');
    const subtext = el.querySelector('.banner-subtext, .subtitle, p');
    // Con botón secundario entra la FILA de los dos (utils/boton-secundario.js); sin él, el botón.
    const ctaBtn  = el.querySelector('.n3i-botones, .btn-action, [data-field="cta"], .btn');
    const section = el.querySelector('section');

    // Estado inicial forzado estricto para evitar FOVC
    if (section) { section.style.opacity = '0'; }
    if (textEl)  { textEl.style.opacity = '0'; }
    if (subtext) { subtext.style.opacity = '0'; }
    if (ctaBtn)  { ctaBtn.style.opacity = '0'; ctaBtn.style.transform = 'translateY(15px)'; }
    if (badge)   { badge.style.opacity = '0'; badge.style.transform = 'scale(0.9)'; }

    const tl = createTimeline({ defaults: { ease: EASE.refined }, });

    // 1. Entrada fluida de la sección de fondo (sin deformar escala)
    if (section) {
        tl.add(section, {
            opacity: [0, 1],
            duration: resolveDuration(DURATION.normal),
            ease: EASE.refined,
        }, 0);
    }

    // 2. Revelación de texto premium por palabras (Título)
    if (textEl) {
        textEl.style.opacity = '1';
        try {
            const split = splitText(textEl, { words: true, characters: false });
            if (split.words?.length) {
                split.words.forEach(w => {
                    w.style.opacity = '0';
                    w.style.display = 'inline-block';
                });
                tl.add(split.words, {
                    opacity:    [0, 1],
                    translateY: [12, 0],
                    filter:     [BLUR.light, BLUR.none],
                    delay:      stagger(20),
                    duration:   resolveDuration(DURATION.normal),
                    ease:       SPRING_PRESETS.deluxe,
                }, section ? '-=250' : 50);
            }
        } catch(e) {
            tl.add(textEl, {
                opacity:    [0, 1],
                translateY: [12, 0],
                filter:     [BLUR.normal, BLUR.none],
                duration:   resolveDuration(DURATION.normal),
                ease:       SPRING_PRESETS.deluxe,
            }, section ? '-=250' : 50);
        }
    }

    // 3. Subtexto (Descripción) fade-up
    if (subtext) {
        tl.add(subtext, {
            opacity:    [0, 1],
            translateY: [8, 0],
            duration:   resolveDuration(DURATION.fast),
            ease:       EASE.refined,
        }, '-=250');
    }

    // 4. Botón de acción (CTA) con spring elástico magnético al final
    if (ctaBtn) {
        tl.add(ctaBtn, {
            opacity:    [0, 1],
            translateY: [15, 0],
            duration:   resolveDuration(DURATION.normal),
            ease:       SPRING_PRESETS.magnetic,
        }, '-=200');
    }

    // 5. Badge o Icono
    if (badge) {
        tl.add(badge, {
            opacity:    [0, 1],
            scale:      [0.9, 1],
            duration:   resolveDuration(DURATION.fast),
            ease:       SPRING_PRESETS.magnetic,
        }, '-=200');
    }

    return tl;
};
